import { Schema } from 'firebase/ai';
import { arraySchema, objectSchema } from './schemaBuilders.js';

const scoreRecommendationSchema = objectSchema({
  category: Schema.string(),
  title: Schema.string(),
  details: Schema.string(),
  priority: Schema.string(),
});

export const scoreOutputSchema = objectSchema({
  score: Schema.number(),
  maxScore: Schema.number(),
  percentage: Schema.number(),
  summary: Schema.string(),
  improvements: arraySchema(Schema.string()),
  checklist: arraySchema(
    objectSchema({
      id: Schema.string(),
      passed: Schema.boolean(),
      pointsAwarded: Schema.number(),
      reason: Schema.string(),
    })
  ),
});

export const scoreOutputWithDescriptionsSchema = objectSchema({
  score: Schema.number(),
  maxScore: Schema.number(),
  percentage: Schema.number(),
  summary: Schema.string(),
  improvements: arraySchema(Schema.string()),
  recommendations: arraySchema(scoreRecommendationSchema),
  checklist: arraySchema(
    objectSchema({
      id: Schema.string(),
      passed: Schema.boolean(),
      pointsAwarded: Schema.number(),
      description: Schema.string(),
    })
  ),
});
